import axios from 'axios';
export const baseUrl = "https://api.benice.ir/";
axios.defaults.baseURL = baseUrl;

const username = 'Store';
const password = 'g3oC7M60geLehscK3cQQHIdfQPyGaeh47mI36RgvhzM4MDl0s9335g74OBSnJRz4FALQzK427zK';
let authHeader = {
    'Authorization': 'Basic ' + btoa(username + ':' + password)
}

export const GetListPack = async () => {
    return await axios.get(baseUrl + `ListPack`, {
        headers:
            authHeader
    })
};
export const GetListGroupKala = async (params) => {
    return await axios.get(baseUrl + `ListGroupKala`, {
        headers:
            authHeader
    })
};

export const GetfactorPdf= async (params) => {
    return await axios.get(baseUrl + `PrintOrder?UserId=${params.userId}&OrderId=${params.factorId}`, {
        headers:
            authHeader
    })
};
export const GetInfo= async () => {
    return await axios.get(baseUrl + `WhyBen`, {
        headers:
            authHeader
    })
};

export const GetpaymentImg= async (params) => {
    return await axios.get(baseUrl + `Fish?UserId=${params.userId}&PardakhtId=${params.factorId}`, {
        headers:
            authHeader
    })
};
export const GetReport= async (params) => {
    return await axios.get(baseUrl + `ReportMali?UserId=${params.userId}&FromDate=${params.fromDate}&ToDate=${params.toDate}`, {
        headers:
            authHeader
    })
};
export const GetProductByCategory = async (params) => {
    return await axios.get(baseUrl + `KalahaInGroups?Id_Grp=${params.productGroupId}`, {
        headers:
            authHeader
    })
};

export const GetProductsbBySearch = async (params) => {
    return await axios.get(baseUrl + `Kalaha?Filter=${params}`, {
        headers:
            authHeader
    })
};

export const GetProductsbById = async (params) => {
    return await axios.get(baseUrl + `FullInfoKala?Code=${params}`, {
        headers:
            authHeader
    })
};
export const GetProducts = async (params) => {
    return await axios.get(baseUrl + `Kalaha`, {
        headers:
            authHeader
    })
}; 


export const GetBestProducts = async (params) => {
    return await axios.get(baseUrl + `PorForush`, {
        headers:
            authHeader
    })
}; 

export const GetLastProducts = async (params) => {
    return await axios.get(baseUrl + `LastForush`, {
        headers:
            authHeader
    })
}; 
export const GetBanners = async (params) => {
    return await axios.get(baseUrl + `Slids`, {
        headers:
            authHeader
    })
};
export const GetContact = async (params) => {
    return await axios.get(baseUrl + `FooterData`, {
        headers:
            authHeader
    })
};
export const GetContactUs = async (params) => {
    return await axios.get(baseUrl + `Contact`, {
        headers:
            authHeader
    })
};
export const GetContactBanner = async (params) => {
    return await axios.get(baseUrl + `SlidsContc`, {
        headers:
            authHeader
    })
};
export const GetQuestions = async (params) => {
    return await axios.get(baseUrl + `QuestionCommon`, {
        headers:
            authHeader
    })
};


export const loginApi = async (params) => {
    try {
        return await axios.post(baseUrl + `LoginStore?LoginName=${params.mobile}&Pass=${params.password}&IIP=${params.ip}`, {}, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};


export const checkMobile = async (params) => {
    return await axios.get(baseUrl + `ConfirmMobile?Mobile=${params}`, {
        headers:
            authHeader
    })
};
export const sendNewCode = async (params) => {
    return await axios.post(baseUrl + `SendNewCode?MLE=${params}`,{}, {
        headers:
            authHeader
    })
};
export const getBasketList = async (params) => {
    return await axios.get(baseUrl + `Basket_List?UserId=${params}`, {
        headers:
            authHeader
    })
};
export const getCustomerDebt = async (params) => {
    return await axios.get(baseUrl + `BedehiCoustomer?UserId=${params}`, {
        headers:
            authHeader
    })
};
export const deleteBasket = async (params) => {
    return await axios.get(baseUrl + `BasketDel?UserId=${params.userId}&Id=${params.id}`, {
        headers:
            authHeader
    })
};
export const addBasket = async (params) => {
    return await axios.get(baseUrl + `BasketAdd?UserId=${params.userId}&KalaId=${params.id}&Nq=${params.count}&Tp=${params.description}`, {
        headers:
            authHeader
    })
};
export const Register = async (params) => {
    return await axios.post(baseUrl + `NewUser`,params, {
        headers:
            authHeader
    })
};
export const forgotPassword = async (params) => {
    return await axios.post(baseUrl + `ChangePassWithCode?MLE=${params.mobile}&Code=${params.code}&NewPass=${params.newPass}`,params, {
        headers:
            authHeader
    })
};
export const getDiscountProduct = async (params) => {
    return await axios.get(baseUrl + `Discount?Id_Kala=${params}`, {
        headers:
            authHeader
    })
};
export const getGallery = async (params) => {
    return await axios.get(baseUrl + `GaleriSelected`, {
        headers:
            authHeader
    })
};
export const getUserInfo = async (params) => {
    return await axios.get(baseUrl + `Profile_Info?UserId=${params}`, {
        headers:
            authHeader
    })
};

export const UpdateUserInfo = async (params) => {
    return await axios.post(baseUrl + `UpdateInfo`,params, {
        headers:
            authHeader
    })
};

export const changePass = async (params) => {
    return await axios.post(baseUrl + `UpdatePas?UserId=${params.UserId}&Pass=${params.Pass}&NewPass=${params.NewPass}&Login=${params.Login}`,{}, {
        headers:
            authHeader
    })
};

export const addAddress = async (params) => {
    return await axios.post(baseUrl + `AddAddress`,params, {
        headers:
            authHeader
    })
};

export const getAddress = async (params) => {
    return await axios.get(baseUrl + `ListAddressCustomerAll?UserId=${params}`, {
        headers:
            authHeader
    })
};
export const getProvince = async (params) => {
    return await axios.get(baseUrl + `ListOstan`, {
        headers:
            authHeader
    })
};
export const getCity = async (params) => {
    return await axios.get(baseUrl + `ListCity?OstanId=${params}`, {
        headers:
            authHeader
    })
};

export const getHelp = async (params) => {
    return await axios.get(baseUrl + `Help_A`, {
        headers:
            authHeader
    })
};


export const getNotification = async (params) => {
    return await axios.get(baseUrl + `Elanat?UserId=${params}`, {
        headers:
            authHeader
    })
};


export const changeStatusNotification = async (params) => {
    return await axios.post(baseUrl + `ElanatRead?UserId=${params.userId}&ElanId=${params.notifId}`,params, {
        headers:
            authHeader
    })
};


//favorite
export const getFavoriteList = async (params) => {
    return await axios.get(baseUrl + `Karbar_ListLikeKala?UserId=${params}`, {
        headers:
            authHeader
    })
};
export const getAddToFavorite = async (params) => {
    return await axios.post(baseUrl + `Karbar_AddLikeKala?UserId=${params.userId}&KalaId=${params.productId}`,params, {
        headers:
            authHeader
    })
};
export const deleteFavorite = async (params) => {
    return await axios.post(baseUrl + `Karbar_DeletLikeKala?UserId=${params.UserId}&KalaId=${params.productId}`,params, {
        headers:
            authHeader
    })
};

//tickey
export const getTicketList = async (params) => {
    return await axios.get(baseUrl + `ListMsgHeader?UserId=${params.userId}&Act=${params.status}`, {
        headers:
            authHeader
    })
};
export const addTicket = async (formData, params) => {
    return await axios.post(baseUrl + `MsgNew?UserId=${params.userId}&Onvan=${params.title}&Sharh=${params.desc}&Factor=${params.orderId}`,formData, {
        headers:
            authHeader
    })
};

export const closeTicketApi = async ( params) => {
    return await axios.post(baseUrl + `MsgHdClose?UserId=${params.userId}&HdId=${params.id}`,params, {
        headers:
            authHeader
    })
};

export const answerTicket = async (formData, params) => {
    return await axios.post(baseUrl + `MsgAnswer?UserId=${params.userId}&HdId=${params.id}&Sharh=${params.answer}`,formData, {
        headers:
            authHeader
    })
};
export const getMessageTicket = async ( params) => {
    return await axios.get(baseUrl + `MsgDetail?UserId=${params.userId}&HdId=${params.ticketId}`, {
        headers:
            authHeader
    })
};
export const getTicketById = async ( params) => {
    return await axios.get(baseUrl + `MsgHeader?UserId=${params.userId}&HdId=${params.ticketId}`, {
        headers:
            authHeader
    })
};


export const confirmFactor= async ( params) => {
    return await axios.post(baseUrl + `ConfirmFactor`,params, {
        headers:
            authHeader
    })
};

export const GetAllOrders= async ( params) => {
    return await axios.get(baseUrl + `reportOrders?UserId=${params.userId}&FromDate=${params.fromDate}&ToDate=${params.toDate}&Sit=${params.status}&Num=${params.factorNum}`, {
        headers:
            authHeader
    })
};
export const getOpenOrders= async ( params) => {
    return await axios.get(baseUrl + `OpenOrders?UserId=${params.userId}`, {
        headers:
            authHeader
    })
};
export const customerFactor= async ( params) => {
    return await axios.get(baseUrl + `OrderDetails?UserId=${params.userId}&OrderId=${params.orderId}`, {
        headers:
            authHeader
    })
};
export const getDeliverDate= async ( params) => {
    return await axios.get(baseUrl + `DeliverDate`, {
        headers:
            authHeader
    })
};
export const getOrderInfo= async (params) => {
    return await axios.get(baseUrl + `OrderInfo?UserId=${params.userId}&OrderId=${params.orderId}`, {
        headers:
            authHeader
    })
};

export const payment = async (params) => {
    return await axios.post(baseUrl + `ElamiyePardakht`,params, {
        headers:
            authHeader
    })
};






export const CheckMobile = async (params) => {
    return await axios.get(baseUrl + `CheckMobile?Mobile=${params}`, {
        headers:
            authHeader
    })
};

export const UpdateCustomer = async (params) => {
    return await axios.post(baseUrl + 'UpdateCustomer',params, {
        headers:
            authHeader
    })
};
export const ChangePass = async (params) => {
    return await axios.post(baseUrl + 'ChangePass',params, {
        headers:
            authHeader
    })
};
export const SabtShekayat = async (params) => {
    return await axios.post(baseUrl + 'SabtShekayat',params, {
        headers:
            authHeader
    })
};
export const sendCodeApi = async (params) => {
    return await axios.get(baseUrl + `SendCode?Mobile=${params}`, {
        headers:
            authHeader
    })
};




// const api = async (method, url, params = null) => {
//     if (method === 'get') {
//         // if params exist, must be passed as string url query like 'mobile=09374008234&gender=m'
//         return await axios.get(`${url}?${!!params?params:''}`, { headers: authHeader, withCredentials:false, });
//     }
//     else if (method === 'post') {
//         return await axios.post(url, params, { headers: authHeader, withCredentials:false });
//     }
// };
// export const GetCustomerInfo = async(query) => {
// await api('get' , 'CustomerInfo' , query)
// }